import React from 'react';
import { MdPayment, MdTrendingUp } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import TableLoadingWrapper from './TableLoadingWrapper';
import '../../styles/views.css';

const PaymentMethodsView = ({
  pagedFilteredData,
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
  loading,
  userRole,
  userMmdaId,
}) => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {/* Header */}
      <div style={{
        marginBottom: 16,
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: isMobile ? '12px' : '0',
      }}>
        <input
          type="text"
          placeholder="Search payment methods..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{
            width: isMobile ? '100%' : 300,
            padding: '8px 12px',
            borderRadius: 4,
            border: '1px solid #ccc',
            fontSize: isMobile ? 14 : 16,
            outline: 'none',
          }}
        />
        
        <div style={{
          padding: '10px 16px',
          backgroundColor: '#f3e5f5',
          color: '#7b1fa2',
          border: '1px solid #e1bee7',
          borderRadius: 6,
          fontSize: 14,
          fontWeight: 'bold',
          width: isMobile ? '100%' : 'auto',
          textAlign: isMobile ? 'center' : 'left'
        }}>
          Regional Payment Overview
        </div>
      </div>

      {/* Payment Methods Table */}
      <TableLoadingWrapper loading={loading}>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Payment Method</th>
                <th>Description</th>
                <th>Regional Usage</th>
                <th>Total Amount</th>
                <th>Success Rate</th>
                <th>Status</th>
                <th>Last Used</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedFilteredData.map((row, i) => (
                <tr key={i} style={{ cursor: 'default' }}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <MdPayment size={16} style={{ color: '#7b1fa2' }} />
                      <strong>{row.method_name || row.name}</strong>
                    </div>
                  </td>
                  <td>{row.description || 'No description available'}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                      <MdTrendingUp size={14} style={{ color: '#2e7d32' }} />
                      <span style={{
                        padding: '4px 8px',
                        backgroundColor: '#e8f5e8',
                        borderRadius: 4,
                        fontSize: 12,
                        fontWeight: 'bold',
                        color: '#2e7d32'
                      }}>
                        {row.usage_count || 0} transactions
                      </span>
                    </div>
                  </td>
                  <td>
                    <strong style={{ color: '#2e7d32', fontSize: 14 }}>
                      GH₵ {parseFloat(row.total_amount || 0).toFixed(2)}
                    </strong>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: '#e3f2fd',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      color: '#1976d2'
                    }}>
                      {((row.success_rate || 0) * 100).toFixed(1)}%
                    </span>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      backgroundColor: row.status === 'active' ? '#e8f5e8' : '#ffebee',
                      color: row.status === 'active' ? '#2e7d32' : '#c62828'
                    }}>
                      {(row.status || 'active').charAt(0).toUpperCase() + (row.status || 'active').slice(1)}
                    </span>
                  </td>
                  <td>{row.last_used ? new Date(row.last_used).toLocaleDateString() : 'Never'}</td>
                  <td>
                    <div style={{
                      display: 'flex',
                      flexDirection: isMobile ? 'column' : 'row',
                      gap: isMobile ? '4px' : '8px',
                      alignItems: isMobile ? 'stretch' : 'center'
                    }}>
                      <button
                        onClick={() => console.log('View payment method analytics:', row)}
                        style={{
                          padding: isMobile ? '6px 8px' : '6px 12px',
                          backgroundColor: '#1976d2',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: isMobile ? 11 : 12,
                          width: isMobile ? '100%' : 'auto',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        Analytics
                      </button>
                      <button
                        onClick={() => console.log('View transactions for method:', row)}
                        style={{
                          padding: isMobile ? '6px 8px' : '6px 12px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: isMobile ? 11 : 12,
                          width: isMobile ? '100%' : 'auto',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        Transactions
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>

      {/* Pagination */}
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
      )}

      {/* Payment Methods Info */}
      <div style={{
        marginTop: 20,
        padding: 15,
        backgroundColor: '#f3e5f5',
        borderRadius: 8,
        border: '1px solid #e1bee7',
        fontSize: 14,
        color: '#7b1fa2'
      }}>
        <strong>Payment Method Oversight:</strong> Monitor payment method usage and performance within your MMDA region. 
        Track transaction volumes, success rates, and identify popular payment preferences.
      </div>
    </>
  );
};

export default PaymentMethodsView;
